const Redux = {
  combineHandlers: (handlers, defaultState) => function reducer (state = defaultState, action) {
    const handler = handlers[action.type]
    return handler ? handler(state, action) : state
  },
}

export default Redux
